import { gql } from 'graphql-tag'
import { fragmentModuleNavigationLink } from '../../modules/fragments'
import { fragmentGlobalDataTheme } from '../../global-data/fragments'

export default gql`
  ${fragmentModuleNavigationLink}
  ${fragmentGlobalDataTheme}
  fragment BlockIndexHighlightFragment on BlockIndexHighlight {
    sys {
      id
    }
    title
    text {
      json
    }
    isFullScreen
    link {
      ...ModuleNavigationLinkFragment
    }
    theme {
      ...GlobalDataThemeFragment
    }
  }
`
